<timeline-content
  [items]="items"
  (resultEvent)="openEventResultModal($event)"
  (scheduleEvent)="openFutureEventCreationModal()"
></timeline-content>
